import { AdminLeavesSection } from '../attendance/sections';
import { AdminVouchersSection } from '../vouchers/sections';

export default function AdminModulePage() {
  return (
    <>
      <AdminVouchersSection />
      <AdminLeavesSection />
    </>
  );
}
